<template>
  <div class="flex flex-col my-auto">
    <div class="flex mx-auto mb-6">
      <div @click="cardClick('sub-process-one')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">HOW TO <br>MAKE <br> MONEY</h4>
      </div>
      <div @click="cardClick('sub-process-two')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">IAI <br>CREATIVE- <br>CONCEPT</h4>
      </div>
      <div @click="cardClick('sub-process-three')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">RESEARCH</h4>
      </div>
      <div @click="cardClick('sub-process-four')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">NEURO LAB + HISTORY</h4>
      </div>
      <div @click="cardClick('sub-process-five')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">GLOSSARY</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProcessIndex",
  methods:{
    cardClick(cardName){
      Event.$emit('clickedCard', cardName);
    }
  }
}
</script>

<style lang="css" scoped>
.circles{
  width: 14rem;
  height: 14rem;
}

@media (min-width: 1024px){

  .circles{
    width: 10rem;
    height: 10rem;
  }

}

@media (min-width: 1280px){

  .circles{
    width: 12rem;
    height: 12rem;
  }

}

@media (min-width: 1367px){

  .circles{
    width: 14rem;
    height: 14rem;
  }

}

@media (min-width: 1500px){

  .circles{
    width: 14rem;
    height: 14rem;
  }

}

@media (min-width: 1550px){

  .circles{
    width: 14rem;
    height: 14rem;
  }

}

@media (min-width: 2000px){

  .circles{
    width: 16rem;
    height: 16rem;
  }

}
</style>
